import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Phytoremediation refers to the ability of certain plants to
              bioaccumulate, degrade, or render harmless contaminants in soil,
              water, etc. Wetlands function as kidneys of a landscape as plants
              in wetlands aid as sinks by uptake of nutrients and heavy metals.
              The current study focuses on estimating the phytoremediation
              potential of select wetland plants. Plant samples were collected
              from inlets and outlets of Jakkur wetlands, Bengaluru on weekly
              basis. The plants were identified using standard keys based on
              taxonomic literatures. Plants identified are <em>Typha</em> sp.,{" "}
              <em>Cyperus</em> sp., <em>Ludwigia</em> sp.,{" "}
              <em>Pistia stratiotes</em>, <em>Polygonum</em> sp.,{" "}
              <em>Alternanthera philoxeroides </em>and <em>Spirodela</em> sp.,
              which are perennial. Among these, <em>Typha</em> sp.,{" "}
              <em>Cyperus</em> sp.,<em> Pistia stratiotes</em> and{" "}
              <em>Spirodela</em> sp. are monocots, and <em>Ludwigia</em> sp.,{" "}
              <em>Polygonum</em> sp. and <em>Alternanthera philoxeroides </em>
              are dicots. These plants showed the uptake of the heavy metals
              viz., cadmium, zinc, nickel, copper, chromium and lead. During the
              1<sup>st</sup> week, uptake of Cu and Zn was more by young{" "}
              <em>Typha </em>sp. at inlet and Cr was more at outlet of sampling.
              The uptake of Cu, Pb, Zn and Ni was 1.4, 9.0, 9.4 and 10.0 mg/kg
              respectively during the 2<sup>nd</sup> week of sampling in young{" "}
              <em>Typha</em> sp. shoot. Also, the Pb and Zn uptake was 13.6 and
              10.4 mg/kg respectively in the mature <em>Typha</em> sp. during
              the 3<sup>rd</sup> week at outlet of sampling. Ni uptake was 4.0
              mg/kg during the 3<sup>rd</sup> week of sampling by mature{" "}
              <em>Typha </em>sp. at inlet. The uptake of Pb, Zn and Cd was 12.2,
              23.0 and 1.4 mg/kg respectively during the 4<sup>th</sup> week of
              sampling in the mature <em>Typha</em> sp. at outlet. The uptake of
              Pb, Ni, Cr and Cd was 5.2, 2.4, 12 and 0.8 mg/kg respectively
              during the 1<sup>st</sup> week of sampling in the medium{" "}
              <em>Polygonum</em> sp. The uptake of Zn was 10.2 mg/kg during the
              2<sup>nd</sup> week in the mature{" "}
              <em>Alternanthera philoxeroides </em>at outlet of sampling. The
              uptake of Cr was 19.6 mg/kg during the 3<sup>rd</sup> week was
              found to be more by mature <em>Alternanthera philoxeroides </em>at
              outlet of sampling. The uptake of Cu, Pb, Zn and Cr was 2.2, 9.8,
              8.6 and 10.2 mg/kg respectively during the 4<sup>th</sup> week in
              young <em>Alternanthera philoxeroides </em>at inlet. Similarly,
              the uptake of Cr was 13.6 mg/kg from outlet during the 2
              <sup>nd</sup> week in <em>Spirodela</em> sp. The uptake of Cu was
              2.4 mg/kg during the 3<sup>rd</sup> week in medium{" "}
              <em>Ludwigia</em> sp. at outlet.
            </p>
            <p>
              <strong>Keywords:</strong>{" "}
              <em>
                Phytoremediation, Macrophytes, Physiology, Wetland, Nutrients,
                Perennial
              </em>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
